import React, {useEffect, useState} from 'react';
import {ArrowCircleRightOutlined} from "@mui/icons-material";
import Checkbox from "./Checkbox";
import Box from "@mui/material/Box";
import {Button} from "@mui/material";
import HeaderWithSubHeader from "../components/HeaderWithSubHeader";
import TextQuestionWithIcon from "../components/TextQuestionWithIcon";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const Reframe = ({step, steps, handleNext, handleBack, activeStep, handleSetStepSummary}) => {
    const [canMoveOn, setCanMoveOn] = useState(true);
    const [reframes, setReframes] = useState(
        [
            {
                isSelected: false,
                label: 'Labeling',
                description: "Defining a person based on one action or characteristic. \"I said something embarrassing. I'm such a loser.\""
            },
            {
                isSelected: false,
                label: 'Negative Feeling or Emotion',
                description: "Getting \"stuck\" on a distressing thought, emotion, or belief."
            },
            {
                isSelected: false,
                label: 'Blaming',
                description: "Giving away your own power to other people. \"It's not my fault I yelled. You made me angry!\""
            },
            {
                isSelected: false,
                label: 'Mind Reading',
                description: "Assuming you know what someone else is thinking. \"She didn't say hello. She must be mad at me.\""
            },
            {
                isSelected: false,
                label: 'Should Statements',
                description: "Setting unrealistic expectations for yourself. \"I shouldn't need to ask for help. I should be independent.\""
            }
        ]
    );

    useEffect(() => {
        const selectedTitles = step.summary;
        if(!selectedTitles) {
            return;
        }
        const array = selectedTitles.split('; ');
        const newThinkingTrap = [...reframes].map((reframe) => {
            if(array.includes(reframe.title)) {
                reframe.isSelected = true;
            }
            return reframe;
        });
        setReframes(newThinkingTrap);
    }, [activeStep, steps, reframes, step]);

    const toggleThinkingTrap = (trap) => {
        let index = reframes.findIndex(t => t.label === trap.label && t.description === trap.description);
        const newThinkingTrap = [...reframes];
        if (index !== -1) {
            newThinkingTrap[index] = {
                ...newThinkingTrap[index],
                isSelected: !newThinkingTrap[index].isSelected
            };
            setReframes(newThinkingTrap);
        }
    };

    const validate = () => {
        let selectedCount = 0;
        reframes.forEach((trap) => {
            if(trap.isSelected) {
                selectedCount++;
            }
        })
        return selectedCount>0 && selectedCount <4;
    }

    const handleLocalNext = () => {
        // validate at least one selection..
        if(!validate()) {
            setCanMoveOn(false);
            return;
        }
        setCanMoveOn(true);
        const selectedLabels = reframes.filter(trap => trap.isSelected).map(trap => trap.label).join("; ");
        handleSetStepSummary({...step, summary: selectedLabels});
        handleNext();
    };

    return (
        <div style={{display: "flex", justifyContent: "flex-start", flexDirection: "column", textAlign: "left"}}>
            <HeaderWithSubHeader steps={steps} step={step}/>
            <br/>

            <div className="blue-box shadow-sm">
                <TextQuestionWithIcon text=" What is Reframing?" icon={<InfoOutlinedIcon />} />
                <p style={{marginLeft: "5px", fontSize: "16px", marginTop: "10px"}}>We overcome thinking traps by coming up with new ways to think about the situation we are dealing with. This process is called <b>reframing.</b></p>
                <p style={{marginLeft: "5px", fontSize: "16px", marginTop: "10px"}}>What can you tell yourself to think about this situation in a <b>more positive, realistic, or helpful way?</b></p>

            </div>
            <br/>
            <div style={{marginLeft: "10px"}}>
                <TextQuestionWithIcon text="Reframe Your Thinking" icon={<ArrowCircleRightOutlined />} subtitle="Here are a few reframes you may consider. Click on the reframe you find most relatable and helpful to start working on it or add your own reframe."/>

                <Checkbox toggleThinkingTrap={toggleThinkingTrap} thinkingTrap={reframes}/>
            </div>

            <br/>

            {!canMoveOn && (<>
                <p className="fs-5-5" style={{color: "black", marginLeft: "10px", fontSize: "14px"}}><mark style={{backgroundColor: "#FFB0B0", padding: "0.2em"}}><b>Note:</b> You may select more than one thinking traps (up to three)</mark></p>
                <br/>
            </>)}

            <div style={{display: "flex", justifyContent: "center"}}>
                <Box sx={{mb: 2}}>
                    <div>
                        <Button
                            variant="outlined"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{mt: 1, mr: 1}}
                            style={{borderRadius: "100px"}}
                        >
                            Previous
                        </Button>

                        <Button
                            variant="outlined"
                            onClick={handleLocalNext}
                            sx={{mt: 1, mr: 1}}
                            style={{borderRadius: "100px"}}
                        >
                            {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                        </Button>
                    </div>
                </Box>
            </div>
        </div>
    );
};

export default Reframe;